import {getStore} from "trim-redux";
import {makeStyles} from "@mui/styles";
import {theme} from "../../../../../config/design/theme";

const useStyles = makeStyles(() => {
    return {
        navItem: {
            height: 50,
            marginTop: 6,
            marginBottom: 2,
            cursor: 'pointer',
            fontFamily:"wSiteFont !important",
            textDecoration: 'none !important',
            textAlign:"right",
            borderRadius:12,
            '&.nav-item-header': {
                textTransform: 'uppercase',
            },
            '&.active': {
                backgroundColor: theme.palette.primary.main,
                pointerEvents: 'none',
                transition: '.15s cubic-bezier(0.4,0.0,0.2,1)',
                '& .nav-item-text': {
                    color: "#fff",
                },
                '& .lucide-icon-sidebar': {
                    color: "#fff !important",
                },
            },
            '&:hover': {
                backgroundColor:"#fdf4f5 !important",
            },
            '&:focus': {
                backgroundColor:"#F0051F !important",
                '& .nav-item-text': {
                    color: "#fff  !important",
                },
                color:"#fff !important",
            },
            '&.disabled': {
                backgroundColor: "#fff !important",
                cursor: 'default',
                '& .nav-item-text': {
                    color: "#999",
                },
                '& .lucide-icon-menu': {
                    color: "#999 !important",
                },
            },


            '& .nav-item-icon': {
                color: "#333333",
            },
            '& .nav-item-text': {
                color: "#333333",
                paddingRight:10,
            },

        },
        listIcon: {
            fontSize: 22,
            marginTop: 7
        },
        listItemText: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    };
});
export default useStyles;

